export default __webpack_public_path__ + "static/media/abreNovos.c49b6fb5.jpg";